// extracted by mini-css-extract-plugin
module.exports = {"container":"_2hASY3","best":"_34W8sr","bestseller":"fQt6-D","content":"_35zRcQ","price":"_3X2Y84"};